import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "mt-2 mb-2 d-flex" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "legend-available" }, null, -1)
const _hoisted_3 = { class: "ms-2 me-2" }
const _hoisted_4 = { class: "mt-2 mb-4 d-flex" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "legend-unavailable" }, null, -1)
const _hoisted_6 = { class: "ms-2 me-2" }
const _hoisted_7 = { class: "mt-4 mb-4" }
const _hoisted_8 = { class: "grid-header" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "grid-cell header-cell" }, "Temps", -1)
const _hoisted_10 = { class: "time-slot" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "d-flex justify-content-center mt-5" }
const _hoisted_13 = { class: "indicator-label" }
const _hoisted_14 = { class: "indicator-progress" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

import ApiService from '@/core/services/ApiService'
import { onMounted, ref, Ref } from 'vue'
import { useStore } from 'vuex'
import Swal from 'sweetalert2/dist/sweetalert2.js'
import { useI18n } from 'vue-i18n'
import { AxiosRequestConfig } from 'axios'

interface AvailabilityData {
  [day: string]: {
    [time: string]: boolean
  }
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AvailabilityGrid',
  setup(__props) {

const store = useStore()
const { t } = useI18n()
const loading = ref(true)
const availabilityId = ref<undefined | string>(undefined)
const submitButton = ref()
const days: Ref<string[]> = ref([
  'monday',
  'tuesday',
  'wednesday',
  'thursday',
  'friday',
  'saturday',
])

const timeSlots: string[] = [
  '08:00 - 09:00',
  '09:00 - 10:00',
  '10:00 - 11:00',
  '11:00 - 12:00',
  '12:00 - 13:00',
  '13:00 - 14:00',
  '14:00 - 15:00',
  '15:00 - 16:00',
  '16:00 - 17:00',
  '17:00 - 18:00',
]

const availability: Ref<AvailabilityData> = ref({
  monday: {},
  tuesday: {},
  wednesday: {},
  thursday: {},
  friday: {},
  saturday: {},
})

const toggleAvailability = (day: string, time: string) => {
  console.log(day, time, availability.value[day][time])
  availability.value[day][time] = !availability.value[day][time]
}

const saveAvailability = () => {
  submitButton.value!.disabled = true
  submitButton.value?.setAttribute('data-kt-indicator', 'on')
  const data = {}
  days.value.forEach((day) => {
    data[day] = Object.keys(availability.value[day])
      .filter((time) => availability.value[day][time])
      .map((time) => ({
        start: time.split(' - ')[0],
        end: time.split(' - ')[1],
      }))
  })

  if (availabilityId.value)
    ApiService.patch('/teacherAvailability/' + availabilityId.value, { data })
      .then(() => {
        Swal.fire({
          text: t('availability.saved'),
          icon: 'success',
          buttonsStyling: false,
          confirmButtonText: 'Ok!',
          customClass: {
            confirmButton: 'btn btn-primary',
          },
        })
      })
      .catch((err) => {
        console.error(err)
      })
      .finally(() => {
        submitButton.value!.disabled = false
        submitButton.value?.removeAttribute('data-kt-indicator')
      })
  else
    ApiService.put('/teacherAvailability', {
      ...data,
      teacher: store.getters.currentUser._id,
    } as AxiosRequestConfig)
      .then(() => {
        Swal.fire({
          text: t('availability.saved'),
          icon: 'success',
          buttonsStyling: false,
          confirmButtonText: 'Ok!',
          customClass: {
            confirmButton: 'btn btn-primary',
          },
        })
      })
      .catch((err) => {
        console.error(err)
      })
      .finally(() => {
        submitButton.value!.disabled = false
        submitButton.value?.removeAttribute('data-kt-indicator')
      })
}

onMounted(() => {
  ApiService.post('/teacherAvailability/filter', {
    query: {
      teacher: store.getters.currentUser._id,
    },
    aggregation: [],
  })
    .then(({ data }) => {
      if (data.length) {
        data = data[0]
        availabilityId.value = data._id

        days.value.forEach((day) => {
          availability.value[day] = {}
          data[day].map((time) => {
            availability.value[day][time.start + ' - ' + time.end] = true
          })
        })
      } else {
        days.value.forEach((day) => {
          availability.value[day] = {}
          timeSlots.forEach((time) => {
            availability.value[day][time] = true
          })
        })
      }
    })
    .catch((err) => {
      console.error(err)
    })
    .finally(() => {
      loading.value = false
    })
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('availability.available')), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('availability.notAvailable')), 1)
    ]),
    _createElementVNode("h6", _hoisted_7, _toDisplayString(_ctx.$t('availability.note')), 1),
    _createElementVNode("div", _hoisted_8, [
      _hoisted_9,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(days.value, (day) => {
        return (_openBlock(), _createElementBlock("div", {
          key: day,
          class: "grid-cell header-cell"
        }, _toDisplayString(_ctx.$t('timetable.' + day)), 1))
      }), 128))
    ]),
    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(timeSlots, (time, rowIndex) => {
      return _createElementVNode("div", {
        key: rowIndex,
        class: "grid-row"
      }, [
        _createElementVNode("div", _hoisted_10, _toDisplayString(time), 1),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(days.value, (day, colIndex) => {
          return (_openBlock(), _createElementBlock("div", {
            key: colIndex,
            class: _normalizeClass(["grid-cell", {
          'available-cell': availability.value[day][time],
          'unavailable-cell': !availability.value[day][time],
        }]),
            onClick: ($event: any) => (toggleAvailability(day, time))
          }, null, 10, _hoisted_11))
        }), 128))
      ])
    }), 64)),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("button", {
        onClick: saveAvailability,
        class: "btn btn-primary btn-sm mt-10",
        ref_key: "submitButton",
        ref: submitButton,
        id: "kt_save_changes_submit",
        style: {"width":"300px"}
      }, [
        _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.$t('editProfile.saveChanges')), 1),
        _createElementVNode("span", _hoisted_14, [
          _createTextVNode(_toDisplayString(_ctx.$t('pleaseWait')) + " ", 1),
          _hoisted_15
        ])
      ], 512)
    ])
  ]))
}
}

})